<app-esqueleto-tableros [filterWidth]="250">
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <app-filters filtros
    [name]="'filtros.periodo' | translate"
    [array]="periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="yearChange($event)"
    [click]="false"
  />
  <div filtros class="filtroRegionWrap">
    <app-filters
      [name]="'filtros.region' | translate"
      [array]="sucursales" [typeFilter]="Filters.SUCURSALES"
      [click]="false"
      [consolidado]="selectAllSucursales"
      (eventClick)="sucursalChange($event)"
    />
    @if(selectAllSucursales){
      <div class="chipsRegionCustom">
        <div class="chipRegionCustom w3-elemento-menu">{{'filtros.consolidado' | translate}}</div>
      </div>
    } @else if(sucursalesSeleccionadas.length > 0){
      <div #chipsRegionViewport class="chipsRegionCustom">
        @for (suc of sucursalesChipsVisibles; track suc.name) {
          <div class="chipRegionCustom w3-elemento-menu">{{suc.name}}</div>
        }
        @if(hayMasSucursalesSeleccionadas){
          <div class="chipRegionCustom puntos" [matMenuTriggerFor]="menuMasRegiones">···</div>
          <mat-menu #menuMasRegiones="matMenu" xPosition="before">
            <div class="chipsRegionMenu">
              @for (suc of sucursalesSeleccionadas; track suc.name) {
                <div class="chipRegionCustom w3-elemento-menu">{{suc.name}}</div>
              }
            </div>
          </mat-menu>
        }
      </div>
    }
  </div>
  <app-filters filtros
    [name]="'filtros.ind' | translate"
    [array]="perspectives" [typeFilter]="Filters.PERSPECTIVES"
    [click]="false"
    (eventClick)="perspectiveChange($event)"
  />
  <div borrador class="borradorZona">
    <div class="w3-button w3-dropdown-click iconoBorrarFiltros"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="borrarFiltros()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
  <div contenido class="zonaContenido2" [ngClass]="{'conTendencia': !skeleton && viewTabla}">
    @if(!skeleton){
      <div class="zonaTarjetas2Anexo1">
        @for (per of perspectives; track per; let t = $index) {
          @if(per.check){
            <app-scroll-container orientation="horizontal" [class.tarjetasCompactas]="per.tarjetas.length > 4">
              @for (tarjeta of per.tarjetas; track tarjeta; let i = $index) {
                <app-tarjetas class="tarjeta"
                  [header]="'comercial.colocacion.anexo1.tabla'+(t+1)+'T'+(i+5) | translate"
                  [valueStr]="(tarjeta | formaterNumber:2:',':'.') + ' %'"
                  [siceHeader]="'1.5rem'"
                  [siceValue]="'2.2rem'"
                  [footer]="periodoSelect"
                  [icon]="''"
                />
              }
            </app-scroll-container>
          }
        }
      </div>
      <div class="zonaGraficaAnexo1">
        <div class="headerTabla">
          <div class="titulo">
            @for (per of perspectives; track per; let t = $index) {
              @if (per.check){
                <span class="w3-titulo-contenidomenuSC">{{per.name}}</span>
                <span class="w3-margin-left-contenido">&bull;</span>
                @if(viewTabla){
                  <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles}} · {{periodoSelect}}</span>
                }@else{
                  <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles2}} · {{periodoSelect}}</span>
                }
              }
            }
          </div>
          <div class="menu">
            @if(!viewTabla){
              <mat-icon class="iconoMen" (click)="etiquetasShow=!etiquetasShow">{{etiquetasShow?'label_off':'label'}}</mat-icon>
            }
            <mat-icon class="iconoMen" (click)="modal= true">zoom_out_map</mat-icon>
            <mat-icon [matMenuTriggerFor]="menuPrincipal" class="iconoMen">more_vert</mat-icon>
          </div>
        </div>
        <div class="graficaReal">
          @if(viewTabla){
            <div class="tablaReal w3-scroll">
              @for (per of perspectives; track per; let t = $index) {
                @if(per.check){
                  <table class="w3-table allBordes">
                    <thead>
                      <tr class="w3-table-title">
                        @for (head of per.encabezados; track $index; let last = $last) {
                          <th class="w3-border-right-balance w3-center enSticky"
                            [class.colIcono]="$index === 0"
                            [class.colRegion]="$index === 1"
                            [class.colCartera]="$index === 2 || $index === 3"
                            [class.colCumplimiento]="$index === 4"
                            [class.colIndicador]="$index >= 5 && !last"
                            [class.colCriticidad]="last">
                            @if(head === 0){
                              <mat-icon class="iconoMen" (click)="expandirElements('consolidado')">{{expandAll?'expand_less': 'expand_more'}}</mat-icon>

                            }@else{
                              {{ 'comercial.colocacion.anexo1.tabla'+(t+1)+'T' + head | translate }}
                            }
                          </th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (region of regiones; track $index) {
                        @if (region.visible) {
                          <tr class="w3-table-trtd filaRegion">
                            <td class="borderAllLow marginIzq">
                              <mat-icon class="iconoMen" (click)="expandirElements(region)">{{region.check?'expand_less': 'expand_more'}}</mat-icon>
                            </td>
                            <td class="borderAllLow marginIzq">
                              {{region.description}}
                            </td>
                            <td class="borderAllLow marginDer colCartera celdaDerecha">
                              {{ formatMeta(region.meta) }}
                            </td>
                            <td class="borderAllLow marginDer colCartera celdaDerecha">
                              {{region.measures.carteraTotal | formaterNumber:2:',':'.'}}
                            </td>
                            <td class="borderAllLow marginDer colCumplimiento celdaDerecha">
                              {{ getCumplimientoMeta(region.measures.carteraTotal, region.meta) }}
                            </td>
                            @for (column of per.columns; track $index) {
                              <td class="borderAllLow colIndicador celdaDerecha">
                                <div class="marginDer celdaAltura" [ngClass]="getIndicatorClass(region.measures[column.field], column.limit)"
                                matTooltip="{{'comercial.colocacion.anexo1.meta' | translate}}: &le; {{column.limit}}">
                                  {{ region.measures[column.field] | formaterNumber:2:',':'.' }}
                                </div>
                              </td>
                            }
                            <td class="borderAllLow marginDer colCriticidad celdaDerecha">
                            </td>
                          </tr>
                          @if (region.check) {
                            @for (sucursal of region.sucursales; track $index) {
                              <tr class="w3-table-trtd">
                                <td class="borderAllLow marginIzq">
                                </td>
                                <td class="borderAllLow marginIzq">
                                  {{sucursal.description}}
                                </td>
                                <td class="borderAllLow marginDer colCartera celdaDerecha">
                                  {{ formatMeta(sucursal.meta) }}
                                </td>
                                <td class="borderAllLow marginDer colCartera celdaDerecha">
                                  {{sucursal.measures.carteraTotal | formaterNumber:2:',':'.'}}
                                </td>
                                <td class="borderAllLow marginDer colCumplimiento celdaDerecha">
                                  {{ getCumplimientoMeta(sucursal.measures.carteraTotal, sucursal.meta) }}
                                </td>
                                @for (column of per.columns; track $index) {
                                  <td class="borderAllLow colIndicador celdaDerecha">
                                    <div class="marginDer celdaAltura" [ngClass]="getIndicatorClass(sucursal.measures[column.field], column.limit)"
                                    matTooltip="{{'comercial.colocacion.anexo1.meta' | translate}}: &le; {{column.limit}}">
                                      {{ sucursal.measures[column.field] | formaterNumber:2:',':'.' }}
                                    </div>
                                  </td>
                                }
                                <td class="borderAllLow colCriticidad celdaCentro" [style.box-shadow]="'inset -8px 0 0 0 ' + getCriticidadColor(getCriticidad(sucursal.code))">
                                  {{ getCriticidad(sucursal.code) }}
                                </td>
                              </tr>
                            }
                          }
                        }
                      }
                    </tbody>
                  </table>
                }
              }
            </div>
          }@else{
            <app-graficador #graficas
              [type]="type"
              [labels]="labels"
              [data]="data"
              [colors]="paleta"
              [axisX]="''"
              [axisY]="['']"
              [legend]="{ enabled: true, position: 'bottom' }"
              [etiquetas]="etiquetasShow"
              [formatEtiquetas]="true"
              [zona]="1"
            />
          }
        </div>
      </div>
      @if(viewTabla){
        <div class="zonaTendenciaAnexo1">
          <div class="headerTabla">
            <div class="titulo">
              <span class="w3-titulo-contenidomenuSC">{{ 'graf.tendencia' | translate }}</span>
              <span class="w3-margin-left-contenido">&bull;</span>
              @for (per of perspectives; track per) {
                @if (per.check){
                  <span class="w3-margin-left-contenido w3-subtitulo">{{per.name}}</span>
                }
              }
              @if(tendenciaLabels.length > 0){
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-contenido w3-subtitulo">{{tendenciaLabels[0]}} - {{tendenciaLabels[tendenciaLabels.length-1]}}</span>
              }
            </div>
            <div class="menu">
              <mat-icon class="iconoMen" (click)="tendenciaEtiquetasShow=!tendenciaEtiquetasShow">{{tendenciaEtiquetasShow?'label_off':'label'}}</mat-icon>
              <mat-icon class="iconoMen" (click)="modalTendencia= true">zoom_out_map</mat-icon>
              <mat-icon [matMenuTriggerFor]="menuTendencia" class="iconoMen">more_vert</mat-icon>
            </div>
          </div>
          <div class="graficaReal">
            @if(!tendenciaSkeleton){
              <app-graficador #graficaTendencia
                [type]="tendenciaType"
                [labels]="tendenciaLabels"
                [data]="tendenciaData"
                [colors]="paleta"
                [axisX]="''"
                [axisY]="['']"
                [legend]="{ enabled: true, position: 'bottom' }"
                [etiquetas]="tendenciaEtiquetasShow"
                [formatEtiquetas]="true"
                [zona]="3"
              />
            }@else{
              <app-skeleton-table class="graficaCompleta" [columnas]="6" [filas]="4"/>
            }
          </div>
        </div>
      }
    }@else{
      <div class="filaTablaTarjetas">
        <div class="zonaTablaAnexo1">
          <app-skeleton-table class="graficaCompleta" [columnas]="8" [filas]="16"/>
        </div>
        <div class="zonaTarjetasAnexo1S">
          @for (item of tarjetasSkeleton; track $index) {
            <app-skeleton-card/>
          }
        </div>
      </div>
    }
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal" (close)="modal = false" [export]="true"
  [iconoExport]="viewTabla ? 'description' : 'image'" (exportFile)="viewTabla ? exportExcel() : exportImage()">
  <div modal-header>
    @for (per of perspectives; track per; let t = $index) {
      @if (per.check){
        <span class="w3-titulo-contenidomenuSC">{{per.name}}</span>
        <span class="w3-margin-left-contenido w3-titulo-contenidomenuSC">&bull;</span>
        @if(viewTabla){
          <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles}} · {{periodoSelect}}</span>
        }@else{
          <span class="w3-margin-left-contenido w3-subtitulo">{{subtitles2}} · {{periodoSelect}}</span>
        }
      }
    }
  </div>
  <div modal-body class="modalAncho">
    @if(viewTabla){
      <div class="w3-scroll">
        @for (per of perspectives; track per; let t = $index) {
          @if(per.check){
            <table class="w3-table allBordes">
              <thead>
                <tr class="w3-table-title">
                  @for (head of per.encabezados; track $index; let last = $last) {
                    <th class="w3-border-right-balance w3-center enSticky"
                      [class.colIcono]="$index === 0"
                      [class.colRegion]="$index === 1"
                      [class.colCartera]="$index === 2 || $index === 3"
                      [class.colCumplimiento]="$index === 4"
                      [class.colIndicador]="$index >= 5 && !last"
                      [class.colCriticidad]="last">
                      {{ 'comercial.colocacion.anexo1.tabla'+(t+1)+'T' + head | translate }}
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (region of regiones; track $index) {
                  @if (region.visible) {
                    <tr class="w3-table-trtd filaRegion">
                      <td class="borderAllLow marginIzq">
                        <mat-icon class="iconoMen" (click)="region.check=!region.check">{{region.check?'expand_less': 'expand_more'}}</mat-icon>
                      </td>
                      <td class="borderAllLow marginIzq">
                        {{region.description}}
                      </td>
                      <td class="borderAllLow marginDer colCartera celdaDerecha">
                        {{ formatMeta(region.meta) }}
                      </td>
                      <td class="borderAllLow marginDer colCartera celdaDerecha">
                        {{region.measures.carteraTotal | formaterNumber:2:',':'.'}}
                      </td>
                      <td class="borderAllLow marginDer colCumplimiento celdaDerecha">
                        {{ getCumplimientoMeta(region.measures.carteraTotal, region.meta) }}
                      </td>
                      @for (column of per.columns; track $index) {
                        <td class="borderAllLow colIndicador celdaDerecha">
                          <div class="marginDer celdaAltura" [ngClass]="getIndicatorClass(region.measures[column.field], column.limit)">
                            {{ region.measures[column.field] | formaterNumber:2:',':'.' }}
                          </div>
                        </td>
                      }
                      <td class="borderAllLow marginDer colCriticidad celdaDerecha">
                      </td>
                    </tr>
                    @if (region.check) {
                      @for (sucursal of region.sucursales; track $index) {
                        <tr class="w3-table-trtd">
                          <td class="borderAllLow marginIzq">
                          </td>
                          <td class="borderAllLow marginIzq">
                            {{sucursal.description}}
                          </td>
                          <td class="borderAllLow colCartera celdaDerecha">
                            {{ formatMeta(sucursal.meta) }}
                          </td>
                          <td class="borderAllLow colCartera celdaDerecha">
                            {{sucursal.measures.carteraTotal | formaterNumber:2:',':'.'}}
                          </td>
                          <td class="borderAllLow colCumplimiento celdaDerecha">
                            {{ getCumplimientoMeta(sucursal.measures.carteraTotal, sucursal.meta) }}
                          </td>
                          @for (column of per.columns; track $index) {
                            <td class="borderAllLow colIndicador celdaDerecha">
                              <div class="marginDer celdaAltura" [ngClass]="getIndicatorClass(sucursal.measures[column.field], column.limit)">
                                {{ sucursal.measures[column.field] | formaterNumber:2:',':'.' }}
                              </div>
                            </td>
                          }
                          <td class="borderAllLow colCriticidad celdaCentro" [style.box-shadow]="'inset -8px 0 0 0 ' + getCriticidadColor(getCriticidad(sucursal.code))">
                            {{ getCriticidad(sucursal.code) }}
                          </td>
                        </tr>
                      }
                    }
                  }
                }
              </tbody>
            </table>
          }
        }
      </div>
    }@else {
      <div class="modalGraficaOverflow">
        @if(modal){
          <app-graficador
            [type]="type"
            [labels]="labels"
            [data]="data"
            [colors]="paleta"
            [axisX]="''"
            [axisY]="['']"
            [zona]="2"
            [legend]="{ enabled: true, position: 'bottom' }"
            [etiquetas]="etiquetasShow"
            [formatEtiquetas]="true"
          />
        }
      </div>
    }
  </div>
</app-modal>

<app-modal [isOpen]="modalTendencia" (close)="modalTendencia = false" [export]="true"
  [iconoExport]="'image'" (exportFile)="exportImageTendencia()">
  <div modal-header>
    <span class="w3-titulo-contenidomenuSC">{{ 'graf.tendencia' | translate }}</span>
    <span class="w3-margin-left-contenido w3-titulo-contenidomenuSC">&bull;</span>
    @for (per of perspectives; track per) {
      @if (per.check){
        <span class="w3-margin-left-contenido w3-subtitulo">{{per.name}}</span>
      }
    }
    @if(tendenciaLabels.length > 0){
      <span class="w3-margin-left-contenido w3-titulo-contenidomenuSC">&bull;</span>
      <span class="w3-margin-left-contenido w3-subtitulo">{{tendenciaLabels[0]}} - {{tendenciaLabels[tendenciaLabels.length-1]}}</span>
    }
  </div>
  <div modal-body class="modalAncho">
    <div class="modalGraficaOverflow">
      @if(modalTendencia){
        <app-graficador
          [type]="tendenciaType"
          [labels]="tendenciaLabels"
          [data]="tendenciaData"
          [colors]="paleta"
          [axisX]="''"
          [axisY]="['']"
          [zona]="4"
          [legend]="{ enabled: true, position: 'bottom' }"
          [etiquetas]="tendenciaEtiquetasShow"
          [formatEtiquetas]="true"
        />
      }
    </div>
  </div>
</app-modal>

<mat-menu class="w3-medium" #menuPrincipal="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="menuGrafica">
    <mat-icon class="iconoGris">insert_chart</mat-icon>
    <span class="opcionMenuIndent">{{'menu.graficas' | translate}}</span>
  </button>
  @if( !viewTabla ){
    <button mat-menu-item (click)="viewTabla= true">
      <mat-icon class="iconoGris">table_chart</mat-icon>
      <span class="opcionMenuIndent">{{'graf.tabla' | translate}}</span>
    </button>
  }
  <mat-divider></mat-divider>
  @if(viewTabla){
    <button mat-menu-item (click)="exportExcel()">
      <mat-icon class="iconoGris">description</mat-icon>
      <span class="opcionMenuIndent">{{'menu.exportar' | translate}}</span>
    </button>
  }@else {
    <button mat-menu-item (click)="exportImage()">
      <mat-icon class="iconoGris">image</mat-icon>
      <span class="opcionMenuIndent">{{'menu.exportar' | translate}}</span>
    </button>
  }
</mat-menu>

<mat-menu class="w3-medium" #menuGrafica="matMenu">
  <button mat-menu-item (click)="changeGraph(typeGraphic.AREA)" [disabled]="type === typeGraphic.AREA && !viewTabla">
    <mat-icon class="iconoGris">area_chart</mat-icon>
    <span class="opcionMenuIndent">{{'graf.area' | translate}}</span>
  </button>
  <button mat-menu-item (click)="changeGraph(typeGraphic.BAR)" [disabled]="type === typeGraphic.BAR && !viewTabla">
    <mat-icon class="iconoGris">bar_chart</mat-icon>
    <span class="opcionMenuIndent">{{'graf.barras' | translate}}</span>
  </button>
  <button mat-menu-item (click)="changeGraph(typeGraphic.LINE)" [disabled]="type === typeGraphic.LINE && !viewTabla">
    <mat-icon class="iconoGris">show_chart</mat-icon>
    <span class="opcionMenuIndent">{{'graf.lineal' | translate}}</span>
  </button>
</mat-menu>

<mat-menu class="w3-medium" #menuTendencia="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="menuGraficaTendencia">
    <mat-icon class="iconoGris">insert_chart</mat-icon>
    <span class="opcionMenuIndent">{{'menu.graficas' | translate}}</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="exportImageTendencia()">
    <mat-icon class="iconoGris">image</mat-icon>
    <span class="opcionMenuIndent">{{'menu.exportar' | translate}}</span>
  </button>
</mat-menu>

<mat-menu class="w3-medium" #menuGraficaTendencia="matMenu">
  <button mat-menu-item (click)="changeGraphTendencia(typeGraphic.AREA)" [disabled]="tendenciaType === typeGraphic.AREA">
    <mat-icon class="iconoGris">area_chart</mat-icon>
    <span class="opcionMenuIndent">{{'graf.area' | translate}}</span>
  </button>
  <button mat-menu-item (click)="changeGraphTendencia(typeGraphic.BAR)" [disabled]="tendenciaType === typeGraphic.BAR">
    <mat-icon class="iconoGris">bar_chart</mat-icon>
    <span class="opcionMenuIndent">{{'graf.barras' | translate}}</span>
  </button>
  <button mat-menu-item (click)="changeGraphTendencia(typeGraphic.LINE)" [disabled]="tendenciaType === typeGraphic.LINE">
    <mat-icon class="iconoGris">show_chart</mat-icon>
    <span class="opcionMenuIndent">{{'graf.lineal' | translate}}</span>
  </button>
</mat-menu>
